// extracted by mini-css-extract-plugin
export var base = "_3l-0";
export var updateBanner = "_3l-1";